module.exports = __webpack_public_path__ + "static/media/K2.f1dca530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/K2.png
// module id = 390
// module chunks = 0